// extracted by mini-css-extract-plugin
export var buttons = "bg_cr";
export var container = "bg_b";
export var image = "bg_g";
export var p = "bg_fs";
export var section = "bg_d";
export var short = "bg_ft";
export var textContainer = "bg_cW";